console.log('LCRV Mega Menu JS loaded');

document.addEventListener('DOMContentLoaded', function () {
  const megaMenu = document.getElementById('lcrvMegaMenu');
  if (!megaMenu) {
    console.log('LCRV Mega Menu: #lcrvMegaMenu not found');
    return;
  }

  const shopTrigger = document.querySelector('.lcrv-shop-trigger');

  console.log('Shop Trigger:', shopTrigger);

  if (!shopTrigger) {
    console.log('LCRV Mega Menu: .lcrv-shop-trigger not found');
    return;
  }

  const header = document.querySelector('header');
  let closeTimer;

function openMegaMenu() {
  clearTimeout(closeTimer);

  const wasOpen = megaMenu.classList.contains('is-open');

  megaMenu.classList.add('is-open');

  if (!wasOpen) {
    const tabs = document.querySelectorAll('.lcrv-mega-tab');
    const panels = document.querySelectorAll('.lcrv-mega-panel');

    tabs.forEach(item => item.classList.remove('is-active'));
    panels.forEach(panel => panel.classList.remove('is-active'));

    const firstTab = tabs[0];
    const firstPanel = panels[0];

    if (firstTab) firstTab.classList.add('is-active');

    if (firstPanel) {
      void firstPanel.offsetWidth;
      firstPanel.classList.add('is-active');
    }
  }
}

  function closeMegaMenu() {
    closeTimer = setTimeout(function () {
      megaMenu.classList.remove('is-open');
    }, 150);
  }

  shopTrigger.addEventListener('mouseenter', openMegaMenu);
  shopTrigger.addEventListener('focus', openMegaMenu);

  shopTrigger.addEventListener('mouseleave', function () {
    closeTimer = setTimeout(function () {
      if (!megaMenu.matches(':hover')) {
        megaMenu.classList.remove('is-open');
      }
    }, 150);
  });

  megaMenu.addEventListener('mouseenter', openMegaMenu);
  megaMenu.addEventListener('mouseleave', closeMegaMenu);

  if (header) {
    header.addEventListener('mouseleave', closeMegaMenu);
  }

  const tabs = document.querySelectorAll('.lcrv-mega-tab');
  const panels = document.querySelectorAll('.lcrv-mega-panel');

  tabs.forEach(tab => {
    tab.addEventListener('mouseenter', function () {
      const panelId = this.getAttribute('data-panel');

      tabs.forEach(item => item.classList.remove('is-active'));
      panels.forEach(panel => panel.classList.remove('is-active'));

      this.classList.add('is-active');

      const panel = document.getElementById(panelId);
      if (panel) {
        panel.classList.add('is-active');
      }
    });
  });
});